const DEFAULT_GOVT_ID_TYPE = "Drivers License";

/**
 * Flatten license data into the shape guest forms consume.
 *
 * `firstName` deliberately carries the middle name too. That mirrors what the
 * existing Document AI path already does in useIdScan.ts, so a guest scanned
 * with either scanner ends up with identical form state.
 */
export function toGuestFields(license) {
  const firstName = [license.firstName, license.middleName]
    .filter(Boolean)
    .join(" ");

  return {
    fullName: license.fullName,
    firstName,
    lastName: license.lastName,
    address1: license.address1,
    address2: license.address2,
    city: license.city,
    state: license.state,
    zipcode: license.zipcode,
    country: license.country || "United States",
    govtIdType: DEFAULT_GOVT_ID_TYPE,
    govtIdValue: license.licenseNumber,
    dateOfBirth: license.dateOfBirth,
    gender: license.gender,
  };
}
